import produce from 'immer';
import { CLOSE_ALL_MODALS_FULFILLED, SET_ACTIVE_MODAL_FULFILLED } from '../constants/actions/modalActions';

const navigationReducer = produce(
	(draft, action) => {
		switch (action.type) {
			case SET_ACTIVE_MODAL_FULFILLED: {
				draft.modal = action.payload.modal;
				draft.modalHeading = action.payload.modalHeading;
				draft.modalCallback = action.payload.modalCallback;
				draft.modalQrCodeValue = action.payload.modalQrCodeValue;
				draft.modalLat = action.payload.modalLat;
				draft.modalLng = action.payload.modalLng;
				draft.shipmentId = action.payload.shipmentId;
				draft.page = action.payload.page;
				draft.index = action.payload.index;
				draft.flag = action.payload.flag;
				break;
			}
			case CLOSE_ALL_MODALS_FULFILLED: {
				draft.modal = null;
				draft.modalHeading = null;
				draft.modalCallback = null;
				draft.modalQrCodeValue = null;
				draft.modalLat = null;
				draft.modalLng = null;
				draft.shipmentId = null;
				draft.page = null;
				draft.index = null;
				draft.flag = null;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		modal: null,
	}
);

export default navigationReducer;
